import { ICreateStaticPageRequest } from 'core/model/interfaces/static-pages';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IStaticPagesState } from '../types';

export const createStaticPage = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createStaticPage`,
  async (data: ICreateStaticPageRequest) => {
    try {
      await apiService.staticPages.createStaticPage(data);
      notificationService.global.success('La página estática se ha creado correctamente.');
    } catch (e) {
      const errorMessage = handleErrorMessage(e, 'Ocurrió un error al crear la página estática.');
      showNotificationError(errorMessage);
      throw e;
    }
  },
);

export const createStaticPageReducer: TSliceExtraReducer<IStaticPagesState> = builder =>
  builder
    .addCase(createStaticPage.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createStaticPage.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(createStaticPage.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
